import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { PreloadAllModules, ExtraOptions, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from './shared/shared.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { ApiErrorsInterceptor } from './shared/interceptors/api-errors.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
  enableTracing: false, // for dev only
};
registerLocaleData(localeFr, 'fr-FR');
// Interceptors Provide Array
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiErrorsInterceptor, multi: true },
];
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),

    // Core module of your application
    CoreModule,
    MatDialogModule,
    MatSelectModule,
    // Layout module of your application
    LayoutModule,
    SharedModule,
    HttpClientModule,
    TranslocoRootModule,
    MatMenuModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    httpInterceptorProviders,
    {
      provide: MAT_DATE_LOCALE,
      deps: [TranslocoService],
      useFactory: (translateService: TranslocoService) => translateService.getActiveLang(),
    },
    {
      provide: LOCALE_ID,
      deps: [TranslocoService],
      useFactory: (translateService: TranslocoService) => translateService.getActiveLang(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
